<template>

    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Gallery</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <span>Gallery</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- gallery area start here  -->
        <div class="bd-gallery-area p-relative pt-120 pb-95 p-relative">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="row">
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/c1.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/c1.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/c2.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/c2.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="row">
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/c3.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/c3.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/c4.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/c4.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="row">
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/g1.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/g1.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/g2.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/g2.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="row">
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/g3.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/g3.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="bd-gallery mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                    <div class="bd-gallery-thumb-wrapper">
                                        <div class="bd-gallery-thumb">
                                            <img src="/img/home/g4.png" alt="img not found!">
                                        </div>
                                        <div class="bd-gallery-icon">
                                            <a href="/img/home/g4.png" class="popup-image"><i
                                                    class="flaticon-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!-- gallery area end here  -->

    </main>
</template>
<script>
export default {
    name: "GalleryView",
};
</script>
